import { InternalAxiosRequestConfig } from "axios";
import { useProducersStore } from "@/stores/producers";

export default function producer(config: InternalAxiosRequestConfig): InternalAxiosRequestConfig {
  const producersStore = useProducersStore();
  const producer = producersStore.selected;

  if (!producer.id.includes("0")) {
    config.headers["Producer-Id"] = producer.id.join(",");
  }

  return config;
}
